import type { Holding } from '@/hooks/portfolio/usePortfolio';

type Props = {
  holding: Holding;
};

export const getPortfolioNarrativeFairValue = ({ holding }: Props) => {
  const { company } = holding;
  const { myValuation, defaultNarrative } = company;
  if (myValuation) {
    const { fairValue, type, id, narrative } = myValuation;

    return {
      fairValue: fairValue ?? null,
      valuationId: id ?? null,
      narrativeId: narrative?.id ?? null,
      type: type ?? null,
      owner: narrative?.owner ?? null,
      isSelected: true,
    };
  }

  if (defaultNarrative) {
    const { valuation, id, owner } = defaultNarrative;
    return {
      fairValue: valuation?.fairValue ?? null,
      valuationId: valuation?.id ?? null,
      narrativeId: id ?? null,
      type: valuation?.type ?? null,
      owner: owner ?? null,
      isSelected: false,
    };
  }

  return {
    fairValue: null,
    valuationId: null,
    narrativeId: null,
    type: null,
    owner: null,
    isSelected: false,
  };
};
